module.exports = __webpack_public_path__ + "static/img/case1.cf9c81a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IncentiveTravel/case1.png
// module id = I23o
// module chunks = 1